import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import { ConfirmDialog } from 'components/admin/Dialogs';

import ContentEdit, { Actions, Header, Detail, Side } from './ContentEdit';
import {
  BidsHeader,
  BidsDetail,
  BidsSide,
  BidsTable,
  BidsFilter,
  BidsCards,
  BidsCardsSide,
} from './Bids';

import { getHostingURL } from 'utils';
import { startEditAdmin } from '../../store/actions/admin';
import { startEditPreview } from '../../store/actions/preview';
import { generateBidPDF } from '../../store/generators';
import {
  startAddBid,
  startCopyBid,
  startRemoveBid,
  startEditBid,
 } from '../../store/actions/bids';

import { TooltipTypes } from 'components/admin/Help';

const styles = theme => ({
  root: {
  },
  listView: {
    marginTop: theme.spacing.unit,
    marginRight: theme.spacing.unit*4,
    marginBottom: theme.spacing.unit*4,
    marginLeft: theme.spacing.unit*4,
  },
  detail: {
    marginTop: theme.spacing.unit*2,
    marginLeft: theme.spacing.unit*4,
    marginBottom: theme.spacing.unit*4,
  },
  info: {
    marginTop: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
  },
});

//TODO: figure out a better way to get theme into content editor components
class BidsPage extends Component{
  constructor(props){
    super(props);

    this.state = { showDelete: false };
  }

  handleCancel = () => {
    this.setState({ showDelete: false });
  }

  handleDelete = () => {
    const {
      bid,
      startRemoveBid,
      startEditAdmin,
    } = this.props;

    startRemoveBid(bid.id);
    startEditAdmin({bid: null});
    this.setState({ showDelete: false });
  }

  showDialog = () => this.setState({ showDelete: true });

  render() {
    const {
      classes,
      bid,
      theme,
      help,
      startEditAdmin,
      startRemoveBid,
      startAddBid,
      startCopyBid,
      startEditBid,
      startEditPreview
    } = this.props;
    const { showDelete } = this.state;

    return(
      <div>
        <ConfirmDialog
          open={showDelete}
          title="Delete Bid"
          contentText="This action will delete the bid. Proceed?"
          handleCancel={this.handleCancel}
          handleOk={this.handleDelete}
        />
        {bid &&
          <ContentEdit>
            <Actions
              help={help}
              theme={theme}
              actions={createActions(this.props, this.showDialog.bind(this))}
            />
            <Detail theme={theme}>
              <div className={classes.detail}>
                <BidsDetail />
              </div>
            </Detail>
            <Side theme={theme}>
              <div className={classes.info}>
                <BidsSide />
              </div>

            </Side>
          </ContentEdit>
        }
        {!bid &&
          <div className={classes.listView}>
            <ContentEdit>
              <Header theme={theme}>
                <BidsFilter />
              </Header>
              <Detail theme={theme}>
                <BidsCards />
              </Detail>
              <Side theme={theme}>
                <BidsCardsSide />
              </Side>
            </ContentEdit>
          </div>
        }
      </div>
    );
  }
}

//TODO: implement promises for compound actions
const createActions = (props, showDialog) => {
  const {
    startEditAdmin,
    startAddBid,
    startCopyBid,
    startEditBid,
    startEditPreview,
    bid,
    bidTasks,
    companyInfo,
    client,
    bidValidation
  } = props;

  const actions = [
    {
      value: "Print",
      color: "primary",
      params: { bid, bidTasks, companyInfo, client },
      handleAction: () => {
        // const pdf = generateBidPDF(bid, bidTasks, companyInfo, client);
        // pdf.print();
        let url;
        const hostingURL = getHostingURL();
        const generateURL = `${hostingURL}/generateBidPDF`;

        console.log("COMPANY INFO:", companyInfo);
        const data = {
          "company": {
            "name": companyInfo.companyName,
            "phone": companyInfo.phone,
            "email": companyInfo.email,
            "address": companyInfo.address,
          },
          "client": {
            "name": client.fullName,
            "address": {
              "street": client.address,
              "city": client.city,
              "province": client.province,
              "country": client.country,
              "postalCode": client.postalCode,
            }
          },
          "bid": {
            ...bid,
          },
          "bidTasks": bidTasks.map(task => task),
        }

        fetch(generateURL, {
          mode: 'cors',
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            data,
            token: "LaST18dswfD37VCwVjSsgiselDIDqwwq18iXTvRv"
          })
        })
          .then(response => response.json())
          .then(base64 => {

            console.log("RESULT:", base64);
            // decode base64 string, remove space for IE compatibility
            //NOTE: do this another way, as atob might have compatibility issues???
            //also, cleaner option: Uint8Array.from(atob(base64_string), c => c.charCodeAt(0))
            var binary = atob(base64.pdfDoc.replace(/\s/g, ''));
            var len = binary.length;
            var buffer = new ArrayBuffer(len);
            var view = new Uint8Array(buffer);
            for (var i = 0; i < len; i++) {
                view[i] = binary.charCodeAt(i);
            }

            // create the blob object with content-type "application/pdf"
            var blob = new Blob( [view], { type: "application/pdf" });
            console.log("BLOB", blob);

            url = URL.createObjectURL(blob);
            // console.log("URL:", url);
            window.open(url, '_blank');
            //return url;
          })

      },
    },
    {
      value: "Send",
      color: "primary",
      handleAction: () => {
        const pdf = generateBidPDF(bid, bidTasks, companyInfo, client);
        const toEmail = client.email;

        pdf.getBlob(blob => {
          startEditPreview({
            show: true,
            data: {
              title: "Send Bid",
              type: "send-bid",
              bid: bid,
              bidTasks,
              blob: blob,
              pdf: pdf,
              toEmail,
              client
            }
          });
        });
      },
    },
    {
      type: "divider",
    },
    {
      value: "Duplicate",
      color: "primary",
      handleAction: () => {
        startAddBid({})
          .then((newBid) => startCopyBid(newBid.id, bid.id))
          .then((result) => startEditAdmin({bid: null}))

      },
    },
    {
      value: "Delete",
      color: "primary",
      handleAction: () => {
        showDialog();
      },
    },
    {
      type: "divider",
    },
    {
      value: "Close",
      color: "default",
      tooltipType: TooltipTypes.bid.CLOSE,
      handleAction: () => {
        if(bidValidation.isInvalid) {
          startEditAdmin({ bid: { ...bid, showValidation: true }})
        } else {
          startEditAdmin({bid: null});
        }

      },
    },
  ];

  return actions;
}

BidsPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  const bids = state.bidsState;
  const bid = state.adminState.bid && bids.find(bid => bid.id == state.adminState.bid.id);

  const clients = state.clientsState;

  const account = state.accountState ? state.accountState : {};
  const profile = (account.user && account.user.profile && account.user.profile) ? account.user.profile : {};
  const organization = account.organizations[0] ? account.organizations[0] : {};
  const about = organization.about ? organization.about : {};

  const address = {
    street: about.phone ? about.phone : "",
    city: about.city ? about.city : "",
    province: about.province ? about.province : "",
    country: about.country ? about.country : "",
    postalCode: about.postalCode ? about.postalCode : "",
  };
  const companyInfo = {
    companyName: about.name ? about.name : "",
    companyPhone: about.phone ? about.phone : "",
    companyEmail: profile.email ? profile.email : "",
    address,
  }

  let client;
  let bidTasks;
  let bidValidation = {};
  if (bid) {
    client = clients.find((client) => client.id === bid.clientId);
    bidValidation = state.validation.bids.find(item => item.id === bid.id);
  }
  if (bid) {
    bidTasks = state.bidTasksState.filter(bidTask => bidTask.bidId === bid.id);
  }

  //const companyInfo = state.companyInfoState;
  return({
    bid,
    bidTasks,
    companyInfo,
    client: client ? client : {},
    bidValidation,
    help: state.help,
  })
}

const mapDispatchToProps = {
  startEditAdmin,
  startRemoveBid,
  startAddBid,
  startCopyBid,
  startEditBid,
  startEditPreview,
  generateBidPDF,
}

export default compose(
  withStyles(styles, { withTheme: true }),
  connect(mapStateToProps, mapDispatchToProps)
)(BidsPage);



// WEBPACK FOOTER //
// ./src/components/admin/BidsPage.jsx